import { render, staticRenderFns } from "./createCusomerOrder.vue?vue&type=template&id=679797fb&scoped=true"
import script from "./createCusomerOrder.vue?vue&type=script&lang=js"
export * from "./createCusomerOrder.vue?vue&type=script&lang=js"
import style0 from "./createCusomerOrder.vue?vue&type=style&index=0&id=679797fb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679797fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('679797fb')) {
      api.createRecord('679797fb', component.options)
    } else {
      api.reload('679797fb', component.options)
    }
    module.hot.accept("./createCusomerOrder.vue?vue&type=template&id=679797fb&scoped=true", function () {
      api.rerender('679797fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/customerOrder/createCusomerOrder.vue"
export default component.exports